import 'react';
import styled from '../../../../../../node_modules/@mui/material/styles/styled.mjs';

const CODE_HORIZONTAL_PADDING = 1;
const CodeCore = styled('span')(({ theme })=>({
        borderRadius: 4,
        width: 'fit-content',
        padding: theme.spacing(0.5, CODE_HORIZONTAL_PADDING),
        wordBreak: 'break-word'
    }));

export { CODE_HORIZONTAL_PADDING, CodeCore };
//# sourceMappingURL=Code.mjs.map
